import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'WhFormatter',
  pure: false,
  standalone: true,
})
export class WhFormatterPipe implements PipeTransform {
  transform(value: number | undefined | null, placeholder?: string): string {
    if (value === null || value === undefined) {
      return placeholder ?? '-';
    }

    if (value === 0) {
      return '0 MWh';
    }

    if (value < 1000) {
      return `${Math.round(value)} Wh`;
    }

    const mwh = value / 1000000;

    if (Math.abs(mwh) < 1) {
      return `${Math.round(mwh * 1000)} kWh`;
    }

    // Avoids rounding issues with many decimal points
    return `${Math.round((mwh + Number.EPSILON) * 100) / 100} MWh`;
  }
}
